export const arrayEmpty = [];
export const objectEmpty = {};

export const toLog = (text, data) => {
  //console.log(text, data);
}

export const serializedAll = async (tasks = []) => {
  const results = [];
  for (const task of tasks) results.push(await task());
  return results;
};
